import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './iconOutlineSVG.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */

const DEFAULT_ICON_SIZE = 53;

const IconOutlineSVG = () => {
        const classes = useStyles();

        return (
                <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
                        viewBox='-0.5 -0.5 48.8 49' style={{ 'enable-background': 'new 0 0 47.8 48' }} xmlSpace='preserve'>
                        <g>
                                <path className={classes.st0} d='M23.9,1.1c12.6,0,22.9,10.3,22.9,22.9S36.5,46.9,23.9,46.9S1,36.6,1,24S11.3,1.1,23.9,1.1 M23.9,0.1
                       C10.7,0.1,0,10.8,0,24s10.7,23.9,23.9,23.9S47.8,37.2,47.8,24S37.1,0.1,23.9,0.1L23.9,0.1z'/>
                        </g>
						<defs>
            			    <linearGradient id='monoLinear1' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.01613,164,57.752659)'>
            			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
            			        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
            			        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
            			    </linearGradient>
            			    <linearGradient id='monoLinear2' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(104.098721,0,0,161.004363,59.901279,54.62662)'>
            			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
            			        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
            			        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
            			    </linearGradient>
            			    <linearGradient id='monoLinear3' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.785995,164,57.752659)'>
            			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
            			        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
            			        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
            			    </linearGradient>
            			</defs>
            			<g transform='translate(9 14.5) scale(0.2)'>
            			    <g transform='translate(-287.009995 -55.65802)'>
            			        <g transform='translate(263 3)'>
            			            <g transform='matrix(1.027215,0,0,0.594346,-23.804988,100.522251)'>
            			                <path d='M164,57.753C164,73.07 156.805,85.505 147.942,85.505L77.058,85.505C68.195,85.505 61,73.07 61,57.753C61,42.436 68.195,30 77.058,30L147.942,30C156.805,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear1)' }} />
            			            </g>
            			        </g>
            			        <g transform='translate(263 3)'>
            			            <g transform='matrix(0.919245,0,0,0.594346,-32.063975,67.532896)'>
            			                <path d='M164,57.753C164,73.07 155.96,85.505 146.056,85.505L78.944,85.505C69.04,85.505 61,73.07 61,57.753C61,42.436 69.04,30 78.944,30L146.056,30C155.96,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear2)' }} />
            			            </g>
            			        </g>
            			        <g transform='translate(263 3)'>
            			            <g transform='matrix(1.027215,0,0,0.591787,-4.463251,34.904425)'>
            			                <path d='M164,57.753C164,73.07 156.836,85.505 148.011,85.505L76.989,85.505C68.164,85.505 61,73.07 61,57.753C61,42.436 68.164,30 76.989,30L148.011,30C156.836,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear3)' }} />
            			            </g>
            			        </g>
            			    </g>
            			</g>
                </svg>
        );
};

IconOutlineSVG.propTypes = {
        width: PropTypes.number,
        iconSize: PropTypes.number,
};

IconOutlineSVG.defaultProps = {
        width: 20,
        iconSize: DEFAULT_ICON_SIZE,
};

export default IconOutlineSVG;
